// Compartir UN producto desde Kontrol (inventario, pedidos): el texto con
// precio y talla, y la foto como archivo para el menú de compartir del celular
// (WhatsApp, Instagram, Facebook…). El enlace /p arma la vista previa con foto.
import { simboloMoneda } from '../services/negocioActual';
import { enOferta, precioEfectivo } from './precios';
import { obtenerFotoPrincipal } from './categorias';

export function textoProducto(producto, link = '') {
  const s = simboloMoneda();
  const precio = enOferta(producto)
    ? `${s} ${precioEfectivo(producto)} 🔥 (antes ${s} ${producto.precio_venta})`
    : `${s} ${producto.precio_venta}`;
  const detalles = [producto.talla && `Talla ${producto.talla}`, producto.color].filter(Boolean).join(' · ');
  return [
    `✨ ${producto.nombre}`,
    `💵 ${precio}`,
    detalles && `📏 ${detalles}`,
    link && `👉 ${link}`,
  ].filter(Boolean).join('\n');
}

// Foto principal lista para compartir: JPG de 1080 px (liviana y nítida).
export function urlFotoParaCompartir(producto) {
  const foto = obtenerFotoPrincipal(producto);
  if (!foto) return null;
  const sinProtocolo = String(foto).replace(/^https?:\/\//i, '');
  return `https://images.weserv.nl/?url=${encodeURIComponent(sinProtocolo)}&w=1080&output=jpg&q=88`;
}

const nombreArchivo = (nombre) => `${String(nombre || 'producto').normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 50) || 'producto'}.jpg`;

// Descarga la foto como File (para navigator.share). null si no se pudo.
export async function archivoFoto(producto) {
  const url = urlFotoParaCompartir(producto);
  if (!url) return null;
  try {
    const r = await fetch(url);
    if (!r.ok) return null;
    const blob = await r.blob();
    return new File([blob], nombreArchivo(producto.nombre), { type: 'image/jpeg' });
  } catch { return null; }
}

// ¿El celular puede compartir la foto como archivo?
export function puedeCompartirArchivo(archivo) {
  try {
    return !!(archivo && typeof navigator !== 'undefined' && navigator.canShare && navigator.canShare({ files: [archivo] }));
  } catch { return false; }
}
